// Copyright © 2023 Niphtio, Inc.
// All Rights Reserved.

export const mainMenuMobileHeight = '60px';
export const mainMenuDesktopWidth = '250px';
export const tagsMenuMaxHeight = '30vh';
export const tabPagePadding = '0.75rem'; /* 
value must support negation e.g. -{tabPagePadding} */
